<app-modal
  [title]="'Load customer card' | trans:'cart/card-payment-dialog-modal/header/title'"
  maxWidth="400px"
  [compact]="true"
>
  <ng-template>
    <p>
      {{ 'This customer card has insufficient balance.\nCurrent balance: [[currentBalance]] [[currency]].\n\nShould it be loaded with at least [[minLoadAmount]] [[currency]] or should the remaining balance of [[currentBalance]] [[currency]] be used?' | trans:'cart/card-payment-dialog-modal/message.Text': [['currentBalance', data.currentBalance | numberToCurrency], ['minLoadAmount', data.minLoadAmount | numberToCurrency], ['currency', languageConfig.currency.short]] }}
    </p>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="onCancel()"
      >
        {{ 'Cancel' | trans:'cart/card-payment-dialog-modal/buttons.Cancel' }}
      </button>

      <button
        class="button button--md button--quick-action button--quick-action--blue text-uppercase p-x-16"
        (click)="onLoadCard()"
      >
        {{ 'Load' | trans:'cart/card-payment-dialog-modal/buttons.LoadCard' }}
      </button>
      
      <button
        class="button button--md button--primary text-uppercase"
        (click)="onPartialPayment()"
      >
        {{ 'Use' | trans:'cart/card-payment-dialog-modal/buttons.Use' }}
      </button>
    </div>
  </ng-container>
</app-modal>
